var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftPack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.75C1.25 12.1719 1.57812 12.5 2 12.5H5.75V7.25H1.25V11.75ZM11.75 3.5H10.7422C11.0234 2.98438 11.0938 2.32812 10.7422 1.60156C10.4141 0.898438 9.6875 0.5 8.91406 0.5C7.92969 0.523438 7.29688 1.01562 6.5 2.11719C5.67969 1.01562 5.04688 0.523438 4.0625 0.5C3.28906 0.5 2.5625 0.898438 2.23438 1.60156C1.88281 2.32812 1.95312 2.98438 2.23438 3.5H1.25C0.828125 3.5 0.5 3.85156 0.5 4.25V5.75C0.5 6.17188 0.828125 6.5 1.22656 6.5H11.7266C12.125 6.5 12.4766 6.17188 12.4766 5.75V4.25C12.5 3.85156 12.1484 3.5 11.75 3.5ZM4.08594 3.5C3.57031 3.5 3.14844 3.10156 3.14844 2.5625C3.14844 2.04688 3.57031 1.625 4.08594 1.625C4.55469 1.625 4.90625 1.71875 6.125 3.5H4.08594ZM8.89062 3.5H6.875C8.07031 1.71875 8.42188 1.625 8.89062 1.625C9.40625 1.625 9.82812 2.04688 9.82812 2.5625C9.82812 3.10156 9.40625 3.5 8.89062 3.5ZM7.25 12.5H11C11.3984 12.5 11.75 12.1719 11.75 11.75V7.25H7.25V12.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftPack);
export default __webpack_public_path__ + "static/media/giftPack.9d9ea802f0a9dc44802b92ceef8ef933.svg";
export { ForwardRef as ReactComponent };